import { TaxonomyType } from "data/types";

export class Taxonomy implements TaxonomyType {
    id: string | number;
    name: string;
    href: string;
    taxonomy: "category" | "tag";

    constructor(id: string, name: string, slug: string, type: "category" | "tag") {
        this.id = id;
        //@TODO to be updated after category response update
        this.name = name || 'Industry';
        this.taxonomy = type
        if (type === "category") {
            this.href = `/discover?category=${id}`;
        } else {
            this.href = `/discover?tag=${id}`;
        }
    }
}